import { Xmark } from '@gravity-ui/icons';
import { Button, Modal } from '@gravity-ui/uikit';

import { CANCEL, CONFIRMATION_DELETE, DELETE, DELETE_QUESTION } from '../../../constants';

import styles from './styles.module.scss';

export const DeleteModal = ({ open, setOpen, removeBlock, index }: any) => {
	return (
		<Modal open={open} className={styles.modal}>
			<div className={styles.modal__title}>
				<h3>{CONFIRMATION_DELETE}</h3>
				<Xmark onClick={() => setOpen(false)} cursor="pointer" />
			</div>
			<div className={styles.modal__content}>{DELETE_QUESTION}</div>
			<div className={styles.modal__btns}>
				<Button onClick={() => setOpen(false)} size="xl" view="flat">
					{CANCEL}
				</Button>
				<Button onClick={() => removeBlock(index)} size="xl" view="outlined-danger">
					{DELETE}
				</Button>
			</div>
		</Modal>
	);
};
